import { createContext } from "react";

const workshopContext = createContext();

export default workshopContext;